import { useMemo } from 'react';
import { TabItem } from '../../../components/components.interfaces';
import StudentList from '../subviews/students/studentList.view';
import StudentAttendance from '../subviews/attendance/studentAttendance';
import { StudentAttendanceProvider } from '../contexts/studentAttendance.context';
import StudentFeesView from '../subviews/studentFees/studentFees.view';
import { StudentFeesProvider } from '../contexts/studentFees.context';
import StudentEventsView from '../subviews/studentEvents/studentEvents.view';
import { StudentEventsProvider } from '../contexts/studentEvents.context';
import StudentAssessmentsView from '../subviews/studentAssessments/studentAssessments.view';
import { StudentsProvider } from '../contexts/students.context';
import StudentDocumentsView from '../subviews/studentDocuments/studentDocuments.view';
import { StudentDocumentsProvider } from '../contexts/studentDocuments.context';
import { StudentAssessmentProvider } from '../contexts/studentAssessment.context';
import { useRbacState } from 'src/context/rbac.context';
import { hasReadPermission } from 'src/utils/rbacHelpers';

export const useStudentTabMenuItems = (
  filters: {
    grade: string;
    section: string;
  },
  t: (key: string) => string
): TabItem[] => {
  const { rbac } = useRbacState();

  return useMemo(() => {
    const tabs: TabItem[] = [];

    if (hasReadPermission(rbac, 'students', 'studentList')) {
      tabs.push({
        label: t('students.tabs.list'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: <StudentList />,
      });
    }

    if (hasReadPermission(rbac, 'students', 'attendance')) {
      tabs.push({
        label: t('students.tabs.attendance'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: (
          <StudentAttendanceProvider>
            <StudentAttendance />
          </StudentAttendanceProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'students', 'fees')) {
      tabs.push({
        label: t('students.tabs.fees'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: (
          <StudentFeesProvider>
            <StudentFeesView />
          </StudentFeesProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'students', 'events')) {
      tabs.push({
        label: t('students.tabs.events'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: (
          <StudentEventsProvider>
            <StudentEventsView />
          </StudentEventsProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'students', 'scores')) {
      tabs.push({
        label: t('students.tabs.scores'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: (
          <StudentsProvider>
            <StudentAssessmentProvider>
              <StudentAssessmentsView />
            </StudentAssessmentProvider>
          </StudentsProvider>
        ),
      });
    }

    if (hasReadPermission(rbac, 'students', 'documents')) {
      tabs.push({
        label: t('students.tabs.documents'),
        onClickHandler: () => {
          // do nothing
        },
        tabPanel: (
          <StudentDocumentsProvider>
            <StudentDocumentsView />
          </StudentDocumentsProvider>
        ),
      });
    }

    return tabs;
  }, [rbac, t]);
};
